import * as React from 'react';
import { LoadingScreen } from '../LoadingScreen';
import { ErrorScreen } from '../ErrorScreen';
import { Card } from '../Card';
import * as style from './style.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var LayoutsCards = function LayoutsCards(_ref) {
  var layouts = _ref.layouts,
    isLoading = _ref.isLoading,
    isError = _ref.isError,
    onLayoutCardClick = _ref.onLayoutCardClick,
    onReset = _ref.onReset,
    trackLayoutModalOpen = _ref.trackLayoutModalOpen,
    trackListingLinkClick = _ref.trackListingLinkClick,
    isLayoutModalDisabled = _ref.isLayoutModalDisabled;
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingScreen, {});
  }
  if (isError) {
    return /*#__PURE__*/_jsx(ErrorScreen, {
      onReset: onReset
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: style['cards-list'],
    children: layouts.map(function (layout, i) {
      return /*#__PURE__*/_jsx(Card, {
        layout: layout,
        onClick: onLayoutCardClick,
        trackLayoutModalOpen: trackLayoutModalOpen,
        trackListingLinkClick: trackListingLinkClick,
        isLayoutModalDisabled: isLayoutModalDisabled
      }, i);
    })
  });
};